/* eslint-disable @typescript-eslint/no-magic-numbers */
import { milsToMeters } from "@buildwithflux/shared";
// Default value of 10 originally used here https://github.com/buildwithflux/flux-app/blob/349136a37768c6d82285d91bb4745b5da5012101/packages/core/src/pcb/expression_engine/expression_context/ExpressionContextSystemFunctions.ts#L121
const DefaultTemperatureRise = 10;
// formula from https://www.omnicalculator.com/other/pcb-trace-width
export function calculateTraceWidth(currentInAmps, traceThicknessInMils, layer, desiredTemperatureRiseInCelsius = DefaultTemperatureRise) {
    // Validation for current - possible value of NaN if const context.this?.current is undefined
    // in ExpressionContextSystemFunctions
    if (Number.isNaN(currentInAmps) || currentInAmps <= 0) {
        currentInAmps = 0;
    }
    // Handling NaN case which is possible if context.this?.desiredTemperatureRise is undefined
    // in ExpressionContextSystemFunctions
    if (Number.isNaN(desiredTemperatureRiseInCelsius)) {
        desiredTemperatureRiseInCelsius = DefaultTemperatureRise;
    }
    const copperConstant = layer === "external" ? 0.048 : 0.024;
    const b = 0.44;
    const c = 0.725;
    const area = Math.pow(currentInAmps / (copperConstant * Math.pow(desiredTemperatureRiseInCelsius, b)), 1 / c);
    const width = area / traceThicknessInMils;
    return milsToMeters(width);
}
//# sourceMappingURL=calculateTraceWidth.js.map